import { defineNuxtPlugin } from '#imports';
import Notify from '~/widgets/Notify';

export default defineNuxtPlugin(() => {
  const successMessage = localStorage.getItem(Notify.SUCCESS_MESSAGE_STORAGE_KEY);
  if (successMessage) {
    Notify.success(successMessage);
    localStorage.removeItem(Notify.SUCCESS_MESSAGE_STORAGE_KEY);
  }
})
